module.exports = __webpack_public_path__ + "img/Picture7.27b38d5b.png";